import { getEngineApiClient } from '../../api-client/axios-client.js';

const state = {
    bookingRequestId: 0,
    bookingFailed: false,
    stripeSecret: '',
    paymentFailed: false,
};

const getters = { 
    getBookingRequestPostData: (state, getters, rootState) => {
        return {
            client: { 
                title: rootState.passengers.client.title,
                firstName: rootState.passengers.client.firstName,
                lastName: rootState.passengers.client.lastName,
                email: rootState.passengers.client.email
            },
            airportsSpecified: rootState.transfers.requireTransfers == 'yes',
            passengers: rootState.passengers.passengers,
            pricingRequest: getters.getPricingRequestPostData,
        }
    },
    getPaymentIntentRequestPostData: (state, getters, rootState) => {
        return {
            bookingRequestId: state.bookingRequestId,
            clientEmail: rootState.passengers.client.email,
            currency: 'EUR',
            amount: rootState.dayByDay.pricing.amountToPay,
            description: 'Your holiday to the Real Ireland'
        }
    },
    bookingComplete: (state) => {
        return state.bookingRequestId > 0;
    },
    bookingRef: (state) => { 
        var strRequestId = state.bookingRequestId.toString();
        return 'RIONLINE' + strRequestId.padStart(5, "0");
    }
};

const mutations = {
    setBookingRequestId(state, payload) {
        state.bookingRequestId = payload;
    },
    setBookingFailed(state, payload) {
        state.errorMessage = payload;
    },
    setStripeSecret(state, payload) {
        state.stripeSecret = payload;
    }
};

const actions = {
    async createAxumBooking({ getters, commit, dispatch }) {
        // create booking in axum
        const client = getEngineApiClient();
        const data = getters.getBookingRequestPostData;
        try {
            const response = await client.post('Booking/Create', data);
            
            commit('setBookingRequestId', response.data);
            commit('setBookingFailed', false);
        } catch (error) {
            dispatch('setFatalError', error);  
        }
    },
    async createPaymentIntent({ getters, commit, dispatch }) {
        // create booking in axum
        const client = getEngineApiClient();
        const data = getters.getPaymentIntentRequestPostData;
        try {
            const response = await client.post('/Stripe/PaymentIntents', data);
            
            commit('setStripeSecret', response.data);
        } catch (error) {
            dispatch('resetStripeSecret'); 
        }
    },
    resetStripeSecret({ commit }) {
        commit('setStripeSecret', '');
    }
};

export default { 
    state,
    getters,
    mutations,
    actions
};